import {Box, Center, Image, Text, Flex} from '@chakra-ui/react'
import AvatarRoadmapSummary from '@assets/images/roadmap/avatar-roadmap-summary.png'

const Header = ({
  taskSummary,
  isFinishWeek,
}: {
  taskSummary: any
  isFinishWeek: boolean
}) => {
  return (
    <Box h={{base: 'auto', md: '370px'}} bg={'#339CFF'}>
      {!isFinishWeek && (
        <Box
          h={'100%'}
          w={{base: '100%', md: '900px'}}
          px={{base: 4, md: 0}}
          mx={'auto'}
          position={'relative'}>
          <Flex
            position={{base: 'static', md: 'absolute'}}
            flexDirection={{md: 'row'}}
            alignItems={{base: 'center', md: 'flex-start'}}
            justifyContent={'end'}
            bottom={'90px'}
            gap={'40px'}>
            <Image
              h={{base: '150px', md: '200px'}}
              src={AvatarRoadmapSummary}
              alt="avatar-roadmap-summary"
            />
            <Flex
              flexDirection={'column'}
              justifyContent={'center'}
              color={'white'}
              textAlign={{base: 'center', md: 'left'}}>
              <Text fontSize={{base: '20px', md: '24px'}} fontWeight={'600'}>
                Làm tốt lắm!
              </Text>
              <Text fontSize={{base: '14px', md: '18px'}} fontWeight={'500'}>
                {`Bạn đã hoàn thành ${taskSummary?.task_summary?.number_completed_tasks} bài học trong ${taskSummary?.current_section?.section_name} rồi đấy! Keep it up!`}
              </Text>
            </Flex>
          </Flex>
        </Box>
      )}
    </Box>
  )
}

export default Header
